<template>
    <div class="action-choose-box">

        <div class="chosen-action">
            <el-tag v-for="action in chosenActions" v-bind:key="action.code" class="action-tag" size="small" @close="handleRemoveChosenAction(action)" closable>{{action.name}}</el-tag>
        </div>

        <div class="action-choose-comp">

            <div class="module-tree">
                <module-tree v-model="moduleCode"></module-tree>
            </div>


            <div class="action-table">
                <action-table :moduleCode="moduleCode" :chosenActions="chosenActions"
                            @handleActionChange="handleActionChange"></action-table>
            </div>

        </div>

        <input  type="text" :value="value" style='display:none;'>

    </div>
</template>

<script>
    import ModuleTree from "../ModuleTree";
    import ActionTable from "./ActionTable";

    export default {
        name: "ActionChooseBox",
        components: {ActionTable, ModuleTree},
        props:{
            value: {
                type: Array,
                default:function () {
                    return [] ;
                }
            },
            initActionCodes:{
                type: Array,
                default:function () {
                    return [] ;
                }
            },
        },
        watch: {
            initActionCodes:{
                deep:true,
                handler:function (v) {

                    let vm = this;
                    if(v.length){
                        vm.$http.post(vm.$api.action.list,{codes:v,onPage:false}).then((resp)=>{
                            vm.chosenActions =  resp.data.data.actions;
                        });
                    }

                }
            },
            chosenActions:{
                deep:true,
                handler:function () {
                    let actionCodes = [];
                    this.chosenActions.forEach((action)=>{
                        actionCodes.push(action.code);
                    });
                    this.$emit('input',actionCodes);
                }
            },
            moduleCode(v) {
                console.log(v);
            }
        },
        data() {
            return {
                moduleCode: '',
                chosenActions: []
            }
        },
        methods: {

            handleRemoveChosenAction(action){
                this.chosenActions.splice(this.chosenActions.indexOf(action), 1);
            },

            handleActionChange(action) {

                let srcAction = this.chosenActions.find((r) => {
                    if(!r){
                        return false ;
                    }
                    return action.code === r.code
                });

                if (action.chosen) {

                    if (!srcAction) {
                        this.chosenActions.push(action);
                    }

                } else {

                    if (srcAction) {
                        this.chosenActions.splice(this.chosenActions.indexOf(srcAction), 1);
                    }


                }

            }
        },
        mounted() {

            let vm = this;

        }

    }
</script>

<style lang="scss" scoped>

    .action-choose-box {
        min-height: 500px;
        overflow: hidden;
        border: 1px solid #DCDFE6;
    }

    .chosen-action {
        border-bottom: 1px solid #dcdfe6;
        min-height: 100px;
    }

    .action-choose-comp {
        overflow: hidden;
    }

    .module-tree, .action-table {
        display: inline-block;
        float: left;
    }

    .module-tree {
        width: 179px;
        border-right: 1px solid #dcdfe6;
        min-height: 500px;
        padding: 10px;
    }

    .action-table {
        width: calc(100% - 220px);
        padding: 10px;
    }

    .chosen-action {
        padding: 10px;
    }

    .action-tag {
        margin-right: 10px;
    }

</style>